export default "__VITE_PUBLIC_ASSET__da785084__"